import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Table,
} from "reactstrap";
import axios from "axios";

import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { v4 as uuidv4 } from "uuid";

import moment from "moment";

function TraspasosSalidaCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_TRASPASOS_SALIDA = import.meta.env.VITE_URL_TRASPASOS_SALIDA;
  const URL_ARTICULOS_TS = import.meta.env.VITE_URL_ARTICULOS_TS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_ARTICULOS_PROPORCION = import.meta.env
    .VITE_URL_ARTICULOS_PROPORCION;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [inventarios, setInventarios] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [areas, setAreas] = useState([]);
  const [areaSalida, setAreaSalida] = useState("");
  const [areaDestino, setAreaDestino] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total, setTotal] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inputFields, setInputFields] = useState([
    // {
    //   id: uuidv4(),
    //   articulos: "",
    //   articulosNombre: "",
    //   cantidad: 0,
    //   cantInv: 0,
    //   idInv: "",
    //   costoUnitario: 0,
    //   colores: [],
    //   tallas: [],
    //   colorNombre: "",
    //   tallaNombre: "",
    //   idColor: "",
    //   idTalla: "",
    // },
  ]);

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
      EAN: "",
    },
  ]);

  // Ref para el input del scanner (uncontrolled para evitar race conditions con la pistola)
  const scannerInputRef = useRef(null);

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantInv: 0,
    cantidad: 0,
    colores: [],
    tallas: [],
    total: 0,
  });

  useEffect(() => {
    if (inputFields.length > 0) {
      const totalCantidad = inputFields.reduce(
        (acc, curr) => acc + parseFloat(curr.cantidad || 0),
        0
      );
      setTotal(totalCantidad);
    } else {
      setTotal(0);
    }
  }, [inputFields]);

  // Prevent Enter from submitting the form
  const preventEnterSubmit = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  // Sanitizar código de barras para comparación consistente
  const sanitizeBarcode = (code) => {
    if (!code) return "";
    return code
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .trim();
  };

  async function buscarArticuloSingular(rawScanValue) {
    try {
      // Validate required fields first
      if (!areaSalida || !areaDestino) {
        Swal.fire({
          icon: "error",
          title: "Selecciona Almacenes",
          text: "Debes seleccionar Almacén de Salida y Destino antes de agregar artículos",
        });
        return;
      }
      if (inventarios.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Sin inventario",
          text: "No hay inventario disponible en el almacén de salida seleccionado",
        });
        return;
      }

      const searchValue = rawScanValue.trim();
      const sanitizedValue = sanitizeBarcode(searchValue);

      inventarios.map((a) => {
        // Buscar por eanProporcion (exacto y sanitizado), idArticuloProporcion o _id
        const eanMatch = a.eanProporcion === searchValue || sanitizeBarcode(a.eanProporcion) === sanitizedValue;
        if (eanMatch || a.idArticuloProporcion === searchValue || a._id === searchValue) {

          let idArticulo = a.idArticulo;
          let articulosNombre = a.nombre;
          let colores = a.colores;
          let tallas = a.tallas;
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          let idColor = a.idColor;
          let idTalla = a.idTalla;
          let precio = a.venta;

          const avaible = inputFields.find(
            (i) => i.idArticuloProporcion === a.idArticuloProporcion
          );

          if (avaible) {
            // Validate against available inventory before incrementing
            if (avaible.cantidad + 1 > avaible.cantInv) {
              Swal.fire({
                icon: "error",
                title: "Inventario insuficiente",
                text: `Solo hay ${avaible.cantInv} unidades disponibles de este artículo`,
              });
              return null;
            }

            // Create new array with updated object
            const updatedFields = inputFields.map((field) => {
              if (field.idArticuloProporcion === a.idArticuloProporcion) {
                return {
                  ...field,
                  cantidad: field.cantidad + 1,
                  total: (field.cantidad + 1) * field.precio,
                };
              }
              return field;
            });

            setInputFields(updatedFields);
            return null;
          }

          // const avaiable = inputFields.find((i) => {
          //   if (i.articulos === idArticulo) {
          //     Swal.fire({
          //       icon: "error",
          //       title: "Oops...",
          //       text: "El artículo ya ha sido agregado",
          //       showConfirmButton: false,
          //     });
          //     return true;
          //   }
          //   return false;
          // });
          // if (avaiable) {
          //   return;
          // }
          const newField = {
            id: uuidv4(),
            articulos: idArticulo,
            idInv: idInv,
            cantInv: cantInv,
            articulosNombre: articulosNombre,

            cantidad: 1,
            costoUnitario: a.costoUnitario,

            idTalla: a.idTalla,
            tallaNombre: a.talla,
            idColor: idColor,
            colorNombre: a.color,
            colores: a.colores,
            tallas: a.tallas,
            idArticuloProporcion: a.idArticuloProporcion,
          };

          setInputFields((prev) => [...prev, newField]);

          // Reset only specific fields after adding
          setManualInput((prev) => ({
            ...prev,
            idColor: "",
            articulos: "",
            articulosNombre: "",
            cantidad: 0,
            idTalla: "",
            tallaNombre: "",
            total: 0,
            precio: 0,
            idProporcion: "",
          }));
        }
        return null;
      });
    } catch (error) {
      console.log("error", error);
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }

  const handleManualArticuloChange = (selectedArticulo) => {
    // Filter inventory for the selected article
    let inventario = inventarios.filter(
      (inv) => String(inv.idArticulo) === String(selectedArticulo.idArticulo)
    );

    // Get unique tallas from inventory
    let tallas = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.talla)) {
        acc.push(curr.talla);
      }
      return acc;
    }, []);

    // Get unique colores from inventory
    let colores = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.color)) {
        acc.push(curr.color);
      }
      return acc;
    }, []);

    // Filter selectedArticulo.colores to only include colors present in inventory
    let coloresRed = selectedArticulo.colores.filter((c) =>
      colores.includes(c.name)
    );

    // Filter selectedArticulo.tallas to only include sizes present in inventory
    let tallasRed = selectedArticulo.tallas.filter((t) =>
      tallas.includes(t.name)
    );

    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo.idArticulo,
        articulosNombre: selectedArticulo.nombre,
        idProporcion: "",
        colores: coloresRed,
        tallas: tallasRed,
        idColor: "",
        idTalla: "",
        cantidad: 0,
      });
    }
  };
  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => String(t._id) === String(value));
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        updatedInput.cantidad = parseFloat(value);

        const selectedColor = prev.colores && prev.colores[0];
        const inventario = inventarios.find(
          (inv) =>
            String(inv.idArticulo) === String(prev.articulos) &&
            inv.color === selectedColor?.name &&
            inv.talla === prev.tallaNombre
        );

        if (inventario && updatedInput.cantidad > inventario.cantidad) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `La cantidad excede tu inventario de ${inventario.cantidad}`,
            showConfirmButton: false,
          });
        }
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    // Validate warehouse selection first
    if (!areaSalida || !areaDestino) {
      Swal.fire({
        icon: "error",
        title: "Selecciona Almacenes",
        text: "Debes seleccionar Almacén de Salida y Destino antes de agregar artículos",
      });
      return;
    }
    if (inventarios.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Sin inventario",
        text: "No hay inventario disponible en el almacén de salida seleccionado",
      });
      return;
    }
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Selecciona artículo, color, talla y cantidad",
      });
      return;
    }

    const selectedColor = manualInput.colores.find(
      (c) => c._id === manualInput.idColor
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => t._id === manualInput.idTalla
    );

    const inventario = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(manualInput.articulos) &&
        inv.color === selectedColor.name &&
        inv.talla === selectedTalla.name
    );

    if (!inventario) {
      Swal.fire({
        icon: "error",
        title: "Inventario no encontrado",
        text: "No hay inventario disponible para esta combinación de artículo, color y talla",
      });
      return;
    }

    // Verify that the inventory article matches the selected article
    if (String(inventario.idArticulo) !== String(manualInput.articulos)) {
      Swal.fire({
        icon: "error",
        title: "Error de validación",
        text: "El inventario encontrado no corresponde al artículo seleccionado",
      });
      return;
    }

    const avaible = inputFields.find(
      (i) => i.idArticuloProporcion === inventario.idArticuloProporcion
    );

    if (avaible) {
      // Create new array with updated object
      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
          return {
            ...field,
            cantidad: field.cantidad + manualInput.cantidad,
            total: (field.cantidad + manualInput.cantidad) * field.precio,
          };
        }
        return field;
      });

      setInputFields(updatedFields);
      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        total: 0,
        idProporcion: "",
      }));

      return null;
    }

    const newField = {
      id: uuidv4(),
      articulos: inventario.idArticulo,
      idInv: inventario._id,
      cantInv: inventario.cantidad,
      articulosNombre: inventario.nombre,

      cantidad: parseFloat(manualInput.cantidad),
      costoUnitario: inventario.costoUnitario,

      idTalla: inventario.idTalla,
      tallaNombre: inventario.talla,
      idColor: inventario.idColor,
      colorNombre: inventario.color,
      colores: manualInput.colores,
      tallas: manualInput.tallas,
      idArticuloProporcion: inventario.idArticuloProporcion,
    };

    setInputFields((prev) => [...prev, newField]);

    // Reset only specific fields after adding
    setManualInput((prev) => ({
      ...prev,
      idColor: "",
      articulos: "",
      articulosNombre: "",
      cantidad: 0,
      idTalla: "",
      tallaNombre: "",
      total: 0,
      idProporcion: "",
    }));

  };

  const [expandedTables, setExpandedTables] = useState({});

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveTraspasosSalida = async (event) => {
    event.preventDefault();

    // Validate required fields BEFORE disabling button
    if (!areaSalida) {
      Swal.fire({
        icon: "error",
        title: "Campos requeridos",
        text: "Debes seleccionar un Almacén de Salida",
      });
      return;
    }
    if (!areaDestino) {
      Swal.fire({
        icon: "error",
        title: "Campos requeridos",
        text: "Debes seleccionar un Almacén de Destino",
      });
      return;
    }
    if (areaSalida === areaDestino) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El Almacén de Salida y Destino no pueden ser el mismo",
      });
      return;
    }

    // Validate that we have items to transfer
    const itemsToTransfer = inputFields.filter(item => item.cantidad > 0);

    if (itemsToTransfer.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "No hay artículos con cantidad mayor a 0 para transferir",
      });
      return;
    }

    // Disable button immediately to prevent double-clicks
    setValidaBoton(false);
    toggleProgreso();

    try {

      // Prepare items array
      const items = itemsToTransfer.map((item) => ({
        articulos: item.articulos,
        cantidad: item.cantidad,
        inventarios: item.idInv,
        costoUnitario: item.costoUnitario,
        colores: item.idColor,
        tallas: item.idTalla,
        articulosProporcion: item.idArticuloProporcion,
      }));

      // Send everything in ONE consolidated request
      const response = await axios.post(
        `${URL_TRASPASOS_SALIDA}/batch`,
        {
          fecha,
          areaSalida,
          areaDestino,
          observaciones,
          user: user.id,
          total,
          items,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // Success!
      toggleProgreso();
      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: `Traspaso creado exitosamente con ${response.data.totalArticulos} artículos`,
      });

      setTimeout(() => {
        window.location.reload();
      }, 1500);

    } catch (error) {
      console.error("Error al crear traspaso:", error);
      toggleProgreso();
      setValidaBoton(true);

      // Handle validation errors from backend
      if (error.response?.data?.errors) {
        const errorMessages = error.response.data.errors
          .map((err) => `• ${err.message}`)
          .join("\n");

        Swal.fire({
          icon: "error",
          title: "Error de Validación",
          html: `<div style="text-align: left;">
            <p>Algunos artículos no tienen inventario suficiente:</p>
            <pre style="font-size: 12px; max-height: 300px; overflow-y: auto;">${errorMessages}</pre>
          </div>`,
          width: 600,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Ocurrió un error al procesar el traspaso",
        });
      }
    }
  };
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        costoUnitario: 0,
        colores: [],
        tallas: [],
        colorNombre: "",
        tallaNombre: "",
        idColor: "",
        idTalla: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        const newValue = parseFloat(event.target.value);
        return {
          ...i,
          [event.target.name]: newValue,
          total: i.cantidad * (event.target.name === 'precio' ? newValue : i.precio),
        };
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newValue = parseFloat(event.target.value) || 0;

    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (i.cantInv >= newValue) {
          return {
            ...i,
            cantidad: newValue,
          };
        } else {
          Swal.fire({
            icon: "error",
            title: "Inventario insuficiente",
            text: `Solo hay ${i.cantInv} unidades disponibles. Se ajustó al máximo.`,
            showConfirmButton: true,
          });
          return {
            ...i,
            cantidad: i.cantInv, // Set to max available instead of 0
          };
        }
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function BuscaArticulo(id, event) {
    if (event.target.value.length >= 1) {
      inventarios.forEach((a) => {
        if (a.ean === event.target.value) {
          let articulosNombre = a.codigo + " " + a.nombre;
          let colores = a.colores;
          let tallas = a.tallas;
          let idArticulo = a.idArticulo;
          handleChangeInputArticuloProporcion(
            id,
            idArticulo,
            articulosNombre,
            colores,
            tallas
          );
        }
      });
    } else {
      const newInputArticulos = inputArticulos.map((i) => {
        if (id === i.id) {
          return {
            ...i,
            articulos: event.target.value,
            articulosNombre: "",
            cajas: 0,
            colores: [],
            tallas: [],
          };
        }
        return i;
      });
      setInputArticulos(newInputArticulos);
    }
  }
  const handleChangeInputArticuloUnico = (
    id,
    idArticulo,
    cantInv,
    idInv,
    costoUnitario,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        return {
          ...i,
          articulos: idArticulo,
          cantInv: parseFloat(cantInv),
          idInv: idInv,
          costoUnitario: parseFloat(costoUnitario),
          articulosNombre: articulosNombre,
          colores: colores,
          tallas: tallas,
        };
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  }

  function jalaAlmacenSalida(e) {
    setAreaSalida(e);
    toggleProgreso();

    axios
      .get(`${URL_INVENTARIOS}/traspasos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);

        let unicos = allInventarios.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArticulo === value.idArticulo)
        );
        setArticulosUnicos(unicos);
      })
      .catch((err) => {
        console.log(err);
      });

    setTimeout(() => {
      setModalProgreso(false);
    }, 3000);
  }

  // FIX: jalaAlmacenDestino should NOT reload inventory from destination area
  // The inventory must come from the SOURCE area (areaSalida), not destination
  function jalaAlmacenDestino(e) {
    setAreaDestino(e);
    // Note: We intentionally do NOT reload inventory here
    // The inventory was already loaded from areaSalida in jalaAlmacenSalida
  }

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        return {
          ...i,
          [event.target.name]: event.target.value,
        };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = selectedArticulo.idArticulo;
        let articulosNombre =
          selectedArticulo.codigo + " " + selectedArticulo.nombre;
        let colores = a.colores;
        let tallas = a.tallas;
        handleChangeInputArticuloProporcion(
          id,
          idArticulo,
          articulosNombre,
          colores,
          tallas
        );
      }
    });
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        return {
          ...i,
          articulos: idArticulo,
          articulosNombre: articulosNombre,
          cajas: 0,
          colores: colores,
          tallas: tallas,
        };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    cajas,
    colores,
    tallas
  ) {
    // Validate required fields first
    if (!areaSalida) {
      Swal.fire({
        icon: "error",
        title: "Selecciona Almacén",
        text: "Debes seleccionar un Almacén de Salida antes de agregar artículos",
      });
      return;
    }
    if (!areaDestino) {
      Swal.fire({
        icon: "error",
        title: "Selecciona Almacén",
        text: "Debes seleccionar un Almacén de Destino antes de agregar artículos",
      });
      return;
    }
    if (cajas === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La cantidad debe ser mayor a 0",
      });
      return;
    }
    if (inventarios.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Sin inventario",
        text: "No hay inventario disponible en el almacén de salida seleccionado",
      });
      return;
    }
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;

        const newInputFields = allArticulos
          .map((i, index) => {
            // Match by idArticulo (ObjectId), color name, and talla name
            const inventario = inventarios.find(
              (inv) =>
                String(inv.idArticulo) === String(i.articulos[0]._id) &&
                inv.color === i.colores[0].name &&
                inv.talla === i.tallas[0].name
            );

            if (!inventario) {
              return null;
            }

            // Calcula la cantidad solicitada y la final basada en disponibilidad
            const cantidadSolicitada = i.cantidad * cajas;
            const cantidadFinal = Math.min(inventario.cantidad, cantidadSolicitada);
            const excedeInventario = cantidadSolicitada > inventario.cantidad;

            return {
              id: uuidv4(),
              articulos: inventario.idArticulo,
              idInv: inventario._id,
              cantInv: inventario.cantidad,
              articulosNombre: inventario.nombre,
              cantidadSolicitada: cantidadSolicitada, // Track original request
              excedeInventario: excedeInventario, // Flag if it exceeded
              cantidad: cantidadFinal,
              costoUnitario: inventario.costoUnitario,

              idTalla: i.tallas[0]._id,
              tallaNombre: i.tallas[0].name,
              idColor: i.colores[0]._id,
              colorNombre: i.colores[0].name,
              colores: colores,
              tallas: tallas,
              idArticuloProporcion: i._id,
            };
          })
          .filter((i) => i !== null);

        // SYNCHRONOUS merge and validation BEFORE calling setInputFields
        const errorMessages = [];

        // Get current inputFields synchronously for merge calculation
        const currentFields = [...inputFields];
        const mergedFields = [...currentFields];

        for (const newItem of newInputFields) {
          const existingIndex = mergedFields.findIndex(
            (item) => item.idInv === newItem.idInv
          );

          if (existingIndex !== -1) {
            // Item already exists - update quantity with validation
            const existing = mergedFields[existingIndex];
            const newCantidad = existing.cantidad + newItem.cantidad;

            if (newCantidad > existing.cantInv) {
              errorMessages.push(
                `${existing.articulosNombre} - ${existing.colorNombre} - ${existing.tallaNombre}: Solo hay ${existing.cantInv} disponibles, ya tienes ${existing.cantidad} agregadas`
              );
              // Set to max available
              mergedFields[existingIndex] = {
                ...existing,
                cantidad: existing.cantInv,
              };
            } else {
              mergedFields[existingIndex] = {
                ...existing,
                cantidad: newCantidad,
              };
            }
          } else {
            // New item - check if original request exceeded available inventory
            if (newItem.excedeInventario) {
              errorMessages.push(
                `${newItem.articulosNombre} - ${newItem.colorNombre} - ${newItem.tallaNombre}: Solicitaste ${newItem.cantidadSolicitada}, solo hay ${newItem.cantInv} disponibles`
              );
              // cantidad is already set to max available by Math.min
            }
            mergedFields.push(newItem);
          }
        }

        // Show warning BEFORE updating state
        if (errorMessages.length > 0) {
          Swal.fire({
            icon: "warning",
            title: "Inventario insuficiente",
            html: `<div style="text-align: left; max-height: 300px; overflow-y: auto;">
              <p>Algunos artículos exceden el inventario disponible:</p>
              <ul>${errorMessages.map(msg => `<li>${msg}</li>`).join('')}</ul>
              <p><strong>Se ajustaron las cantidades al máximo disponible.</strong></p>
            </div>`,
            width: 600,
          });
        }

        // Now update state with merged fields
        const tallaOrder = [
            "EECH",
            "ECH",
            "CH",
            "M",
            "G",
            "EG",
            "2EG",
            "3EG",
            "4EG",
            "5EG",
            "6EG",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "50",
            "5/6",
            "7/8",
            "10/12",
            "14/16",
        ];

        // Sort the merged fields
        const sortedInputFields = mergedFields.sort((a, b) => {
          if (a.articulosNombre < b.articulosNombre) return -1;
          if (a.articulosNombre > b.articulosNombre) return 1;

          if (a.colorNombre < b.colorNombre) return -1;
          if (a.colorNombre > b.colorNombre) return 1;

          return (
            tallaOrder.indexOf(a.tallaNombre) -
            tallaOrder.indexOf(b.tallaNombre)
          );
        });

        // Calculate total quantities
        const totalCantidad = sortedInputFields.reduce(
          (acc, curr) => acc + parseFloat(curr.cantidad),
          0
        );

        // Update state with sorted and validated fields
        setInputFields(sortedInputFields);
        setTotal(totalCantidad);

        // Reset input form
        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
            EAN: "",
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const options = useMemo(() => articulosUnicos.map((option) => {
    const junta = option.codigo + " " + option.nombre;
    const firstLetter = option.codigo?.[0]?.toUpperCase() || "#";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  }), [articulosUnicos]);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.traspasos_salida_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Traspaso Salida</h3>
          <Form onSubmit={saveTraspasosSalida}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Salida</Label>
                {user.areas === AREAS_GENERAL ? (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (a._id != AREAS_GENERAL) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                ) : (
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={areaSalida}
                    required
                    onChange={(e) => {
                      jalaAlmacenSalida(e.target.value);
                    }}
                  >
                    <option value="0">Almacen Salida</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.areas === a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                )}
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Almacen Destino</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={areaDestino}
                  required
                  onChange={(e) => {
                    setAreaDestino(e.target.value);
                  }}
                >
                  <option value="0">Almacen Destino</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a._id != AREAS_GENERAL) {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
            </Row>
            <h4 className="text-dark">
              <b>Agregar Caja</b>
            </h4>
            <>
              {/* QR Scanner Input */}
              <Row className=""></Row>

              {/* Proportion Input Section */}
              <Row className="">
                <Col md={2}>
                  <Label className="mr-sm-2">Escanea el QR</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Selecciona</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cajas</Label>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={2}>
                  <Input
                    name="articulos"
                    type="string"
                    value={inputArticulos[0]?.EAN}
                    onKeyDown={preventEnterSubmit}
                    onChange={(event) => {
                      BuscaArticulo(inputArticulos[0].id, event);
                    }}
                  ></Input>
                </Col>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={inputArticulos[0]?.articulosNombre || ""}
                    onChange={(event, selectedArticulo) => {
                      BuscaArticuloProporcion(
                        inputArticulos[0]?.id || "template",
                        selectedArticulo
                      );
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.codigo} {option.nombre}
                      </li>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    name="articulosNombre"
                    type="string"
                    placeholder="Articulo"
                    value={inputArticulos[0]?.articulosNombre || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="cajas"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cajas"
                    value={inputArticulos[0]?.cajas || ""}
                    onKeyDown={preventEnterSubmit}
                    onChange={(event) =>
                      handleChangeInputProporcion(
                        inputArticulos[0]?.id || "template",
                        event
                      )
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="success"
                    disabled={
                      !inputArticulos[0]?.articulos || !inputArticulos[0]?.cajas
                    }
                    onClick={() =>
                      agregarProporcion(
                        inputArticulos[0]?.articulos,
                        inputArticulos[0]?.articulosNombre,
                        inputArticulos[0]?.cajas,
                        inputArticulos[0]?.colores,
                        inputArticulos[0]?.tallas
                      )
                    }
                    tabindex="-1"
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>

              {/* MANUAL PRODUCT SECTION */}
              <h4 className="text-dark">
                <b>Agregar Pieza</b>
              </h4>
              <Row className="">
                <Col md={2}>
                  <Label className="mr-sm-2">Escanea el QR</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Selecciona</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Color</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Talla</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <Input
                    name="idProporcion"
                    type="text"
                    innerRef={scannerInputRef}
                    autoComplete="off"
                    placeholder="Escanear código"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                        const value = scannerInputRef.current?.value || "";
                        if (value.trim().length >= 2) {
                          buscarArticuloSingular(value);
                        }
                        if (scannerInputRef.current) {
                          scannerInputRef.current.value = "";
                        }
                      }
                    }}
                  ></Input>
                </Col>
                <Col md={2}>
                  <Autocomplete
                    size="small"
                    value={manualInput?.articulosNombre || ""}
                    onChange={(event, selectedArticulo) => {
                      handleManualArticuloChange(selectedArticulo);
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.codigo} {option.nombre}
                      </li>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    type="text"
                    value={manualInput?.articulosNombre || ""}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    name="idColor"
                    type="select"
                    value={manualInput?.idColor || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Color</option>
                    {manualInput?.colores?.map((color) => (
                      <option key={color._id} value={color._id}>
                        {color.name}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="idTalla"
                    type="select"
                    value={manualInput.idTalla || ""}
                    onChange={handleManualInputChange}
                  >
                    <option value="">Selecciona Talla</option>
                    {manualInput.tallas &&
                      manualInput.tallas.map((talla) => (
                        <option key={talla._id} value={talla._id}>
                          {talla.name}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    disabled={!manualInput?.idColor || !manualInput?.idTalla}
                    value={manualInput?.cantidad || 0}
                    onKeyDown={preventEnterSubmit}
                    onChange={handleManualInputChange}
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="success"
                    onClick={handleManualAdd}
                    disabled={
                      !manualInput?.articulosNombre ||
                      !manualInput?.idColor ||
                      !manualInput?.idTalla ||
                      !manualInput?.cantidad
                    }
                    tabindex="-1"
                  >
                    Agregar
                  </Button>
                </Col>
              </Row>
            </>

            <br />
            <hr />

            <div>
              {Object.entries(
                inputFields
                  .filter((field) => field.articulosNombre && field.articulos)
                  .reduce((acc, field) => {
                    const key = `${field.articulosNombre}`;
                    if (!acc[key]) {
                      acc[key] = {
                        articuloInfo: {
                          articulosNombre: field.articulosNombre,
                          articulos: field.articulos,
                          availableTallas: Array.from(
                            new Set(
                              inputFields
                                .filter(
                                  (f) =>
                                    f.articulosNombre === field.articulosNombre
                                )
                                .map((f) => f.tallaNombre)
                                .filter(Boolean)
                                .sort((a, b) => {
                                  return (
                                    customSizeOrder.indexOf(a) -
                                    customSizeOrder.indexOf(b)
                                  );
                                })
                            )
                          ),
                        },
                        colorGroups: [],
                      };
                    }

                    const existingColorIndex = acc[key].colorGroups.findIndex(
                      (item) => item.idColor === field.idColor
                    );

                    if (existingColorIndex === -1) {
                      acc[key].colorGroups.push({
                        id: field.id,
                        articulos: field.articulos,
                        articulosNombre: field.articulosNombre,
                        idColor: field.idColor,
                        colorNombre: field.colorNombre,
                        colores: field.colores,
                        quantities: {
                          [field.tallaNombre]: {
                            cantidad: field.cantidad,
                            id: field.id,
                            cantInv: field.cantInv,
                          },
                        },
                      });
                    } else {
                      acc[key].colorGroups[existingColorIndex].quantities[
                        field.tallaNombre
                      ] = {
                        cantidad: field.cantidad,
                        id: field.id,
                        cantInv: field.cantInv,
                      };
                    }
                    return acc;
                  }, {})
              ).map(([articuloNombre, { articuloInfo, colorGroups }]) => {
                // Calculate totals for this article
                const articleTotals = colorGroups.reduce(
                  (totals, group) => {
                    const quantitySum = Object.values(group.quantities).reduce(
                      (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                      0
                    );

                    return {
                      items: totals.items + quantitySum,
                    };
                  },
                  { items: 0, price: 0 }
                );

                return (
                  <div key={articuloNombre} className="mb-8">
                    <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                      <div className="d-flex align-items-center">
                        <Button
                          size="sm"
                          className="btn mr-3"
                          color="info"
                          onClick={() =>
                            setExpandedTables((prev) => ({
                              ...prev,
                              [articuloNombre]: !prev[articuloNombre],
                            }))
                          }
                        >
                          <i
                            className={`fas fa-chevron-${
                              expandedTables[articuloNombre] ? "up" : "down"
                            }`}
                          ></i>
                        </Button>
                        <h4 className="negrita mb-0 mr-4">{articuloNombre}</h4>
                      </div>
                      {!expandedTables[articuloNombre] && (
                        <div className="d-flex align-items-center">
                          <span
                            className="mr-4 text-dark"
                            style={{ fontSize: "18px" }}
                          >
                            <strong style={{ fontSize: "18px" }}>
                              Piezas:
                            </strong>{" "}
                            {articleTotals.items}
                          </span>

                          <span
                            className="text-dark"
                            style={{ fontSize: "18px" }}
                          ></span>
                        </div>
                      )}
                    </div>

                    {expandedTables[articuloNombre] && (
                      <Table borderless>
                        <thead>
                          <tr>
                            <th>Articulo</th>
                            <th>Color</th>
                            {articuloInfo.availableTallas.map((talla) => (
                              <th key={talla} style={{ maxWidth: "35px" }}>
                                {talla}
                              </th>
                            ))}
                            <th style={{ maxWidth: "80px" }}>Disponible</th>

                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {colorGroups.map((group) => (
                            <tr key={`${group.id}-${group.idColor}`}>
                              {/* Your existing row content */}
                              <td>
                                <Input
                                  name="articulo"
                                  type="string"
                                  placeholder="Articulo"
                                  value={group.articulosNombre}
                                  disabled
                                />
                              </td>
                              <td>
                                <Input
                                  name="idColor"
                                  type="select"
                                  value={group.idColor}
                                  onChange={(event) =>
                                    handleChangeInput(group.id, event)
                                  }
                                >
                                  <option value="">Selecciona</option>
                                  {group.colores?.map((a) => (
                                    <option key={a._id} value={a._id}>
                                      {a.name}
                                    </option>
                                  ))}
                                </Input>
                              </td>
                              {articuloInfo.availableTallas.map((talla) => {
                                const tallaData = group.quantities[talla];
                                const hasTalla = !!tallaData;
                                return (
                                  <td key={talla} style={{ maxWidth: "60px" }}>
                                    <Input
                                      name="cantidad"
                                      type="number"
                                      min="0"
                                      step="any"
                                      value={tallaData?.cantidad || 0}
                                      disabled={!hasTalla}
                                      style={!hasTalla ? { backgroundColor: '#f0f0f0' } : {}}
                                      onChange={(event) => {
                                        if (hasTalla) {
                                          handleChangeInputCantidad(tallaData.id, event);
                                        }
                                      }}
                                    />
                                  </td>
                                );
                              })}
                              <td style={{ maxWidth: "100px" }}>
                                <small>
                                  {Object.entries(group.quantities)
                                    .map(([talla, data]) => `${talla}:${data.cantInv}`)
                                    .join(" | ") || "0"}
                                </small>
                              </td>
                              <td>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  disabled={inputFields.length === 1}
                                  onClick={() => handleRemoveFields(group.id)}
                                  tabindex="-1"
                                >
                                  <i className="fas fa-minus"></i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </div>
                );
              })}
            </div>

            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTALES {total} pzas.</h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoTraspasosSalida"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default TraspasosSalidaCreate;
